import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type UserRole = 'admin' | 'operator' | 'viewer';

export interface AuthUser {
  id: string;
  email: string;
  name?: string;
  role: UserRole;
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  setSession: (user: AuthUser, token: string) => void;
  clear: () => void;
  hasScope: (required: UserRole[]) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      setSession: (user, token) => set({ user, token }),
      clear: () => set({ user: null, token: null }),
      hasScope: (required) => {
        const role = get().user?.role;
        return !!role && required.includes(role);
      },
    }),
    {
      name: 'dispatcher.auth',
      partialize: (s) => ({ user: s.user, token: s.token }),
    },
  ),
);
